import './changeHotelInfo.css';
import Hotel from './Hotel';
import Client from './Client';
import HotelAdmin from './HotelAdmin';
const react = require("react");

class ChangeHotelInfoPage extends react.Component{
    constructor(props){
        super(props);
        var role=localStorage.role;
        if(role!='owner'){
            window.location='/search';
        }else if(role===''){
          alert("You are not logged in!");
          window.location='/login';
      }
        var item=JSON.parse(localStorage.hotel).hotel;
        this.hotel=new Hotel(item.id,item.identifier,item.hotelName,item.locationName,item.averageRating,item.votes,item.hotelUrl,item.photoLink,item.description,item.price);
        this.state={
          client:JSON.parse(localStorage.user).user,
          hotelName:item.hotelName,
          identifier:'',
          locationName:item.locationName,
          photoLink:item.photoLink,
          description:item.description,
          price:item.price
        };

        this.client=new Client(this.state.client.username,this.state.client.email,this.state.client.profilePic,this.state.client.auth);
        this.admin=new HotelAdmin(this.client.username,this.client.email,this.client.profilePic,this.client.auth);
    
      }

      myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({[nam] : val});
    }

    update = () =>{
      this.hotel.hotelName=this.state.hotelName;
      this.hotel.identifier=this.state.identifier;
      this.hotel.photoLink=this.state.photoLink;
      this.hotel.locationName=this.state.locationName;
      this.hotel.description=this.state.description;
      this.hotel.price=this.state.price;

      var res=this.hotel.updateHotel(this.hotel,this.admin.auth);
      alert(res.message);
      window.location="/adminProfile";
    }

    render(){
        return( 
<div class="changeHotelInfo">
<div class="topnav">
        <a class="active" href="/">Home</a>
        <a href="/adminProfile">Your profile</a>
        <a href="/statistics">Statistics</a>
        <a href="/login">Sign Out</a>
        <input type="text" placeholder="Search location" name="searchLoc" onKeyUp={this.search} onChange={this.myChangeHandler}/>
    </div>
<hr/>
    <div class="container">
    <div class="row flex-lg-nowrap">
      <div class="col-12 col-lg-auto mb-3" style={{width: '200px'}}>

      </div>

      <div class="col">
        <div class="row">
          <div class="col mb-3">
            <div class="card">
              <div class="card-body">
                <div class="e-profile">
                  <div class="row">
                    <div class="col-12 col-sm-auto mb-3">
                      <div class="mx-auto" style={{width: '140px'}}>
                        <div class="d-flex justify-content-center align-items-center rounded" style={{height: '140px', backgroundColor: 'rgb(233, 236, 239)'}}>
                          <span> <img src={this.hotel.photoLink} alt="Paris" class="d-flex justify-content-center align-items-center rounded" /></span>

                        </div>
                      </div>
                    </div>
                    <div class="col d-flex flex-column flex-sm-row justify-content-between mb-3">
                      <div class="text-center text-sm-left mb-2 mb-sm-0">
                        <h4 class="pt-sm-2 pb-1 mb-0 text-nowrap">{this.hotel.hotelName}</h4>

                      </div>
                      
                    </div>
                  </div>
                  </div>
                  <div class="tab-content pt-3">
                    <div class="tab-pane active">
                      <div class="form" novalidate="">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <label>Name</label>
                                  <input style={{fontSize:'20px'}} class="form-control" type="text" name="hotelName"  value={this.state.hotelName} onChange={this.myChangeHandler}/>
                                </div>
                              </div>
                              <div class="col">
                                <div class="form-group">
                                  <label>Identifier</label>
                                  <input style={{fontSize:'20px'}} class="form-control" type="text" name="identifier"  value={this.state.identifier} onChange={this.myChangeHandler}/>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <label>Location Name</label>
                                  <input style={{fontSize:'20px'}} class="form-control" type="text" name="locationName" value={this.state.locationName} onChange={this.myChangeHandler}/>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <label>Photo Link</label>
                                  <input style={{fontSize:'20px'}} class="form-control" type="text" name="photoLink" value={this.state.photoLink} onChange={this.myChangeHandler}/>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col mb-3">
                                <div class="form-group">
                                  <label>Description</label>
                                  <textarea  style={{fontSize:'20px'}} class="form-control" rows="5" name="description" onChange={this.myChangeHandler}>{this.state.description}</textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-6 mb-3">
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <label>Price</label>
                                  <input style={{fontSize:'20px'}} class="form-control" type="text" id="price" name="price" value={this.state.price} onChange={this.myChangeHandler}/>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>

                            
                        <div class="row">
                          <div class="col d-flex justify-content-end">
                            <button style={{fontSize:'20px'}} class="btn btn-primary" onClick={this.update} type="submit">Save Changes</button>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
    </div>
</div>
            );
    }
}

export default ChangeHotelInfoPage;
